import { useIsAppsUseTranscriptionServiceV2DesktopEnabled } from '@/app-shell/flags/desktop-flags';
import { isTauri } from '@/tauri/utils';
import { useBooleanFlagValue } from '@openfeature/react-sdk';

const DIARISED_TRANSCRIPT_PANE_DESKTOP_FLAG =
  'release-apps-use-diarised-transcript-pane-desktop';

export const useIsDesktopTranscriptionServiceV2ReadSideEnabled = () => {
  const isTranscriptionServiceV2DesktopEnabled =
    useIsAppsUseTranscriptionServiceV2DesktopEnabled();
  const isDiarisedTranscriptPaneDesktopEnabled = useBooleanFlagValue(
    DIARISED_TRANSCRIPT_PANE_DESKTOP_FLAG,
    false
  );

  return (
    isTauri() &&
    isTranscriptionServiceV2DesktopEnabled &&
    isDiarisedTranscriptPaneDesktopEnabled
  );
};
